export default __webpack_public_path__ + "static/media/fastly.dc57389f.svg";